<template>
<div>
  <columns>
    <column>
      <div class="is-flex align-center mb-3">
        <avatar class="mr-2" :name="member.user.name"/>
        <p class="title is-5">{{ member.user.name }}</p>
      </div>
      <div class="columns">
        <div class="column">
          <h4>Permissions</h4>
          <div class="columns is-multiline">
            <div v-for="(permissions, category) in permissions" :key="category" class="column is-3">
              <checkbox-group 
                slug-values 
                :items="permissions" 
                :value="member.permissions"
                @input="updatePermissions">
                {{ category | ucwords }}
              </checkbox-group>
            </div>
          </div>
        </div>
      </div>
    </column>
    <column class="is-narrow">
      <action-button @click="removeMember" class="is-danger is-small">
        <icon icon="trash"/>
      </action-button>
    </column>
  </columns>
</div>
</template>
<script>

export default {
  
  props: {
    permissions: {
      type: Object,
      default: () => ({})
    },
    member: {
      type: Object,
      default: () => ({})
    },
  },

  data: () => ({
    updatingPermissions: false
  }),

  methods: {
    updatePermissions(values) {
      if(!this.updatingPermissions) {
        this.updatingPermissions = true
        this.$store.commit('team/updateMemberPermissions', {
          member: this.member,
          values
        })
        this.$store.dispatch('team/updateMemberPermissions', {
          member: this.member,
          values
        }).then(() => this.updatingPermissions = false)
          .catch(error => this.updatingPermissions = false)
      }
    },
    async removeMember() {
      if(await this.$confirm({
        title: 'Remove Team Member',
        message: 'Are you sure you want to remove this team member?'
      })) {
        this.$store.dispatch('team/removeMember', this.member).then(() => {
          this.$toast.success('Team member removed')
        })
      }
    }
  }

}
</script>